import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CardLabel, FormStep, Loader, RadioOrSelect, TextInput, Toast, UploadFile } from "@egovernments/digit-ui-react-components";
// import InputWrapper from "../pages/citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../pages/citizen/TCPForms/components/Button";
import { useForm } from "react-hook-form";
// import { yesOrNo , statesName } from "../pages/citizen/TCPForms/data";
// import FileUploader from "../pages/citizen/TCPForms/forms/registration/FileUploader";
// import { Col, Container, Row } from "react-bootstrap";

const owners = [{ name: "Ethan Hunt", fatherOrHusbandName: "222-333-4444", mobileNumber: "123-456-7893", emailId: "" }];
const genderData = "abcd";

const ProjectTypList = [
  { code: "Plot-subdivision", name: "Plot-subdivision" },
  { code: "Building_Permsssion_Normal", name: "Building Permsssion-Normal" },
  { code: "Building_Permsssion-Sub_division", name: "Building Permsssion-Sub division" },
  { code: "Integrated_Township", name: "Integrated Township" },
  { code: "Layout_Development", name: "Layout Development" },
  { code: "Building_Permsssion-Group_Development", name: "Building Permsssion-Group Development" },
];
const natureOfConstructionOptions = [
  { code: "NEW_CONSTRUCTION", name: "New" },
  { code: "Addition Extension", name: "Addition Extension" },
  { code: "Redevelopment/Reconstruction ", name: "Redevelopment/Reconstruction " },
];
const planOnOptions = [
  { code: "DA/AVP_Approval_Schemes", name: "DA/AVP Approval Schemes" },
  { code: "Private_Approved_Schemes", name: "Private Approved Schemes" },
  { code: "Others", name: "Others" },
];
const subDevelopmentAreaOptions = [
  { code: "NA", name: "NA" },
  { code: "Metro_City_Area", name: "Metro City Area" },
  { code: "Vilage_Area", name: "Vilage Area" },
  { code: "Other_Town_Area", name: "Other Town Area" },
];
const developmentAreaOptions = [
  { code: "Existing_Builtup_Area/Constructed_Area", name: "Existing Builtup Area/Constructed Area" },
  { code: "Developed_Area", name: "Developed Area" },
  { code: "New_Area", name: "New Area" },
  { code: "Undevelopment_Area", name: "Undevelopment Area" },
  { code: "Undefined_Area", name: "Undefined Area" },
];

const proposalTypeOptions = [
  { code: "Yes", name: "Yes" },
  { code: "No", name: "No" },
];

const EDCRForm2 = ({ t, config, onSelect, formData, isShowToast, isSubmitBtnDisable, setIsShowToast }) => {
  const code = "up";

  const applicationFlow = Digit?.SessionStorage?.get("CITIZEN.COMMON.HOME.FLOW")?.toLowerCase();
  const tcpCode = applicationFlow === "tcp";
  const udCode = applicationFlow === "ud";

  const { data: cityList, isLoading: isCityListLoading } = Digit?.Hooks.useTenants();
  const citymoduleList = (!isCityListLoading && cityList.filter((e) => e?.code?.includes("avp"))?.[0]?.boundary) || [];
  const scrutinyDetails = Digit?.SessionStorage.get(config.key);

  const [selectedCity, setSelectedCity] = useState(scrutinyDetails?.city || null);
  const [localities, setLocalities] = useState(selectedCity?.boundary || null);
  const [selectedLocality, setSelectedLocality] = useState(scrutinyDetails?.locality || null);
  const [areaType, setAreaType] = useState("");
  const selectedLocalityIndex = localities?.findIndex((e) => e.name === selectedLocality?.name);
  const [villages, setVillages] = useState(selectedLocality?.children || localities?.[selectedLocalityIndex]?.children || []);
  const [village, setVillage] = useState(scrutinyDetails?.village || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [name, setName] = useState(scrutinyDetails?.applicantName || formData?.Scrutiny?.[0]?.applicantName);
  const [groundCoverages, setgroundCoverages] = useState(scrutinyDetails?.groundCoverages || formData?.Scrutiny?.[0]?.groundCoverages);
  const [fars, setFars] = useState(scrutinyDetails?.fars || formData?.Scrutiny?.[0]?.fars);
  const [uploadedFile, setUploadedFile] = useState(() => formData?.Scrutiny?.[0]?.proofIdentity?.fileStoreId || null);
  const [file, setFile] = useState(formData?.owners?.documents?.proofIdentity);
  const [uploadMessage, setUploadMessage] = useState("");

  const [landMarks, setLandMarks] = useState(scrutinyDetails?.landMarks || formData?.Scrutiny?.[0]?.landMarks);
  const [natureOfConstruction, setNatureOfConstruction] = useState(
    scrutinyDetails?.natureOfConstruction || formData?.Scrutiny?.[0]?.natureOfConstruction
  );
  const [proposalType, setProposalType] = useState(scrutinyDetails?.proposalType || formData?.Scrutiny?.[0]?.proposalType);
  const [isSpecialProject, setIsSpecialProject] = useState(scrutinyDetails?.isSpecialProject || formData?.Scrutiny?.[0]?.isSpecialProject);
  const [isPlotSetback, setIsPlotSetback] = useState(scrutinyDetails?.isPlotSetback || formData?.Scrutiny?.[0]?.isPlotSetback);
  const [setbackFront, setSetbackFront] = useState(scrutinyDetails?.setbackFront || formData?.Scrutiny?.[0]?.setbackFront);
  const [setbackRear, setSetbackRear] = useState(scrutinyDetails?.setbackRear || formData?.Scrutiny?.[0]?.setbackRear);
  const [backSide, setBackSide] = useState(scrutinyDetails?.backSide || formData?.Scrutiny?.[0]?.backSide);
  const [isApprovedLayout, setIsApprovedLayout] = useState(scrutinyDetails?.isApprovedLayout || formData?.Scrutiny?.[0]?.isApprovedLayout);
  const [projectType, setProjectType] = useState(scrutinyDetails?.projectType || formData?.Scrutiny?.[0]?.projectType);
  const [isRevised, setIsRevised] = useState(scrutinyDetails?.isRevised || formData?.Scrutiny?.[0]?.isRevised);
  const [tehsil, setTehsil] = useState(scrutinyDetails?.tehsil || formData?.Scrutiny?.[0]?.tehsil);
  const [revenueVillage, setRevenueVillage] = useState(scrutinyDetails?.revenueVillage || formData?.Scrutiny?.[0]?.revenueVillage);
  const [planOn, setPlanOn] = useState(scrutinyDetails?.planOn || formData?.Scrutiny?.[0]?.planOn);
  const [sectorNoPlotNo, setSectorNoPlotNo] = useState(scrutinyDetails?.sectorNoPlotNo || formData?.Scrutiny?.[0]?.sectorNoPlotNo);
  const [developmentArea, setDevelopmentArea] = useState(scrutinyDetails?.developmentArea || formData?.Scrutiny?.[0]?.developmentArea);
  const [subDevelopmentArea, setsubDevelopmentArea] = useState(scrutinyDetails?.subDevelopmentArea || formData?.Scrutiny?.[0]?.subDevelopmentArea);
  const [isSpecialYes, setIsSpecialYes] = useState("Upto 300 SqM residential single dwelling unit of santion plan");

  const selectNatureOfConstruction = (option) => {
    setNatureOfConstruction(option);
    formData.natureOfConstruction = option; // Update formData
  };
  const selectsubDevelopmentArea = (option) => {
    setsubDevelopmentArea(option);
    formData.subDevelopmentArea = option; // Update formData
  };
  const selectdevelopmentArea = (option) => {
    setDevelopmentArea(option);
    formData.developmentArea = option; // Update formData
  };
  const selectPlanOn = (option) => {
    setPlanOn(option);
    formData.planOn = option; // Update formData
  };
  const selectProposalType = (option) => {
    setProposalType(option);
    formData.proposalType = option; // Update formData
  };
  const selectIsPlotSetback = (option) => {
    setIsPlotSetback(option);
    formData.isPlotSetback = option; // Update formData
  };
  const selectIsSpecialProject = (option) => {
    setIsSpecialProject(option);
    formData.isSpecialProject = option; // Update formData
  };
  const selectIsApprovedLayout = (option) => {
    setIsApprovedLayout(option);
    formData.isApprovedLayout = option; // Update formData
  };
  const selectIsRevised = (option) => {
    setIsRevised(option);
    formData.isRevised = option; // Update formData
  };
  const selectProjectType = (option) => {
    setProjectType(option);
    formData.projectType = option; // Update formData
  };

  const history = useHistory();

  let validation = {};

  function setApplicantName(e) {
    setName(e.target.value);
  }

  const isSetbackRear = (e) => {
    setSetbackRear(e.target.value); // Update formData
  };
  const setIssetbackFront = (e) => {
    setSetbackFront(e.target.value); // Update formData
  };
  const isSetbackSide = (e) => {
    setBackSide(e.target.value); // Update formData
  };
  function setgroundCoverage(e) {
    setgroundCoverages(e.target.value);
  }
  function setFar(e) {
    setFars(e.target.value);
  }
  function isSpecialProjectYes(e) {
    setIsSpecialYes(e.target.value);
  }
  function setsectorNoPlotNoName(e) {
    setSectorNoPlotNo(e.target.value);
  }
  function setTehsilName(e) {
    setTehsil(e.target.value);
  }
  function setRevenueVillageName(e) {
    setRevenueVillage(e.target.value);
  }
  function setLandMarksName(e) {
    setLandMarks(e.target.value);
  }

  function selectfile(e) {
    setUploadedFile(e.target.files[0]);
    setFile(e.target.files[0]);
  }

  const onSkip = () => {
    setUploadMessage("NEED TO DELETE");
  };

  function selectCity(city) {
    setSelectedCity(city);
    setLocalities(city?.children);
    setOpenVillage(true);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType(city?.Unit);
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    Digit?.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails = { city };
  }

  function selectLocality(locality) {
    if (formData?.landAreaDetails?.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    // const boundaryIndex = localities?.findIndex((e) => e.name === locality.name)
    setSelectedLocality(locality);
    //setVillages(localities?.[boundaryIndex]?.children)
    // setOpenVillage(true)
    //setAreaType(localities?.[boundaryIndex]?.IsSpecialArea ? `Special Area` : `Planning Area`)
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }

  function selectVillage(village) {
    if (formData?.landAreaDetails?.village) {
      formData.landAreaDetails["village"] = village;
    }
    setVillage(village);
    sessionStorage.setItem("currVillage", JSON.stringify(village));
  }

  useEffect(() => {
    if (uploadMessage || isShowToast) {
      setName("");
      setUploadedFile(null);
      setFile("");
      setUploadMessage("");
    }
    if (isShowToast) {
      history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
        data: isShowToast?.label ? isShowToast?.label : "BPA_INTERNAL_SERVER_ERROR",
        type: "ERROR",
      });
    }
  }, [uploadMessage, isShowToast, isSubmitBtnDisable]);

  function onAdd() {
    setUploadMessage("NEED TO DELETE");
  }

  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const watchTODType = watch("orientDevelopment");

  const onSubmit = (data) => {
    handleSubTabChange(1, data);
  };

  const handleSubmits = () => {
    const data = {};
    data.tenantId = code;
    data.city = selectedCity;
    data.areaType = areaType || null;
    data.natureOfConstruction = natureOfConstruction?.name || null;
    data.subDevelopmentArea = subDevelopmentArea?.name || null;
    data.developmentArea = developmentArea?.name || null;
    data.isSpecialProject = isSpecialProject?.name || null;
    data.isApprovedLayout = isApprovedLayout?.name || null;
    data.isPlotSetback = isPlotSetback?.name || null;
    data.planOn = planOn?.name || null;
    data.proposalType = proposalType?.name || null;
    data.isRevised = isRevised?.name || null;
    onSelect(config.key, data);
    data.locality = selectedLocality || null;
    data.village = village || null;
    data.applicantName = name;

    data.tehsil = tehsil;
    data.fars = fars;
    data.sectorNoPlotNo = sectorNoPlotNo;
    data.backSides = backSide;
    data.groundCoverages = groundCoverages;
    data.setbackRears = setbackRear;
    data.setbackFronts = setbackFront;
    data.revenueVillage = revenueVillage;
    data.landMark = landMarks;
    data.file = file || uploadedFile || null;
    Digit?.SessionStorage.set(config.key, data);

    data.locality = selectedLocality?.name || "";
    data.village = village?.name || "";
    data.doorNo = selectedLocality?.name || null;
    onSelect(config.key, data);
  };

  console.log("datakeys", isSpecialProject, subDevelopmentArea?.name, landMarks, natureOfConstruction);

  if (isCityListLoading || isSubmitBtnDisable) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <section className="groupContainer2">
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        <div className="formContainer">
          <FormStep
            t={t}
            config={config}
            onSelect={handleSubmits}
            onSkip={onSkip}
            isDisabled={!selectedCity || !name || !file || isSubmitBtnDisable}
            onAdd={onAdd}
            isMultipleAllow={true}
          >
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("EDCR_COMMON_APPL_NEW")}</h2>
            </div>
            <p>{t("BPA_PROVIDE_REQ_FOR_NEW_BPA")}</p>
            <br />
            {/* Nature of Construction Dropdown (1) */}
            <CardLabel>{`${t("Nature of Construction / Case Type")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={natureOfConstructionOptions}
              selectedOption={natureOfConstruction}
              onSelect={selectNatureOfConstruction}
              optionKey="name"
              placeholder={t("Select Nature of Construction / Case Type")}
            />

            {/* Proposal Type Design Radio Button  (2)*/}
            <CardLabel>{`${t("Proposal Type Design")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              options={proposalTypeOptions}
              selectedOption={proposalType}
              onSelect={selectProposalType}
              optionKey="name"
              isDependent={false}
            />
            {/* Is Revised Radio Button  (3)*/}
            <CardLabel>{`${t("Is Revised")} *`}</CardLabel>

            <RadioOrSelect
              t={t}
              options={proposalTypeOptions}
              selectedOption={isRevised}
              onSelect={selectIsRevised}
              optionKey="name"
              isDependent={false}
            />
            {/* Project Type RadioOrSelect Button  4*/}
            <CardLabel>{`${t("Project Type")} *`}</CardLabel>

            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={ProjectTypList}
              selectedOption={projectType}
              onSelect={selectProjectType}
              optionKey="name"
              placeholder={`Select ${t("City")}`}
            />
            {/* District  RadioOrSelect Button  (5)*/}
            <CardLabel>{`${t("District")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={citymoduleList}
              selectedOption={selectedCity}
              onSelect={selectCity}
              optionKey="name"
              placeholder={`Select ${t("City")}`}
            />

            {/*Tehsil Enter value (6) */}
            <CardLabel>{`${t("Tehsil")} *`}</CardLabel>

            <TextInput
              isMandatory={false}
              optionKey="i18nKey"
              t={t}
              name="tehsil"
              onChange={setTehsilName}
              uploadMessage={uploadMessage}
              value={tehsil}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                type: "text",
                title: t("TL_NAME_ERROR_MESSAGE"),
              })}
            />
            {/*Revenue Village  TextInput (7) */}

            <CardLabel>{`${t("Revenue Village")} *`}</CardLabel>

            <TextInput
              isMandatory={false}
              optionKey="i18nKey"
              t={t}
              name="revenueVillage"
              onChange={setRevenueVillageName}
              uploadMessage={uploadMessage}
              value={revenueVillage}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                type: "text",
                title: t("TL_NAME_ERROR_MESSAGE"),
              })}
            />
            {/* Land Mark  TextInput (8) */}
            <CardLabel>{`${t("Land Mark")} *`}</CardLabel>
            <TextInput
              isMandatory={false}
              optionKey="i18nKey"
              t={t}
              name="landMark"
              onChange={setLandMarksName}
              uploadMessage={uploadMessage}
              value={landMarks}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                type: "text",
                title: t("TL_NAME_ERROR_MESSAGE"),
              })}
            />
            {/*  Plan On  TextInput (9)*/}
            <CardLabel>{`${t("Plan On")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={planOnOptions}
              selectedOption={planOn}
              onSelect={selectPlanOn}
              optionKey="name"
              placeholder={`Select ${t("City")}`}
            />
            {/* Schemes  Radio Select (10)*/}
            {selectedCity && localities?.length > 0 && (
              <span className={"form-pt-dropdown-only"}>
                <CardLabel>{`${t("Schemes")}*`}</CardLabel>
                <RadioOrSelect
                  optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
                  isMandatory={false}
                  options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
                  optionKey="name"
                  selectedOption={selectedLocality}
                  onSelect={selectLocality}
                  t={t}
                  isDependent={true}
                  isDropDown={true}
                />
              </span>
            )}
            {/* Schemes  Radio Select (10)*/}
            {selectedCity && udCode && localities?.length > 0 && (
              <span className={"form-pt-dropdown-only"}>
                <CardLabel>{`${t("Scheme")}*`}</CardLabel>
                <RadioOrSelect
                  optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
                  isMandatory={false}
                  options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
                  optionKey="name"
                  selectedOption={selectedLocality}
                  onSelect={selectLocality}
                  t={t}
                  isDependent={true}
                />
              </span>
            )}

            {selectedCity && selectedLocality && villageOpen && localities?.length > 0 && (
              <div>
                <CardLabel>{`${t("Unit")}`}</CardLabel>
                <TextInput t={t} type={"text"} optionKey="i18nKey" name="areaType" value={areaType} disabled={true} />
              </div>
            )}

            {/*Sector No./Plot No. TextInput (11) */}
            <CardLabel>{`${t("Sector No./Plot No.")} *`}</CardLabel>
            <TextInput
              isMandatory={false}
              optionKey="i18nKey"
              t={t}
              name="sectorNoPlotNo"
              onChange={setsectorNoPlotNoName}
              uploadMessage={uploadMessage}
              value={sectorNoPlotNo}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                type: "text",
                title: t("TL_NAME_ERROR_MESSAGE"),
              })}
            />
            {/* Development Area Dropdown (12) */}
            <CardLabel>{`${t("Development Area")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={developmentAreaOptions}
              selectedOption={developmentArea}
              onSelect={selectdevelopmentArea}
              optionKey="name"
              placeholder={t("Select Development Area")}
            />
            {/* SubDevelopment Area Dropdown (13) */}
            <CardLabel>{`${t("SubDevelopment Area")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
              options={subDevelopmentAreaOptions}
              selectedOption={subDevelopmentArea}
              onSelect={selectsubDevelopmentArea}
              optionKey="name"
              placeholder={t("Select SubDevelopment Area")}
            />
            {/* Is This Special Project Radio Button  (14)*/}
            <CardLabel>{`${t("Is This Special Project")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              options={proposalTypeOptions}
              selectedOption={isSpecialProject}
              onSelect={selectIsSpecialProject}
              optionKey="name"
              isDependent={false}
            />
            {/* Is This Special Project Radio Button  (15)*/}

            {isSpecialProject && isSpecialProject?.name === "Yes" && (
              <span className={"form-pt-dropdown-only"}>
                {/* <CardLabel>{`${t("Schemes")}*`}</CardLabel> */}
                <TextInput
                  isMandatory={false}
                  optionKey="i18nKey"
                  t={t}
                  name="isSpecialYes"
                  onChange={isSpecialProjectYes}
                  uploadMessage={uploadMessage}
                  value={isSpecialYes}
                  {...(validation = {
                    isRequired: true,
                    pattern: "^[a-zA-Z0-9]+(( )+[a-zA-Z0-9]+)*$",
                    type: "text",
                    title: t("TL_NAME_ERROR_MESSAGE"),
                  })}
                />
              </span>
            )}

            {/* Is this Approved Layout Radio Button  (16)*/}
            <CardLabel>{`${t("Is this Approved Layout")} *`}</CardLabel>
            <RadioOrSelect
              t={t}
              options={proposalTypeOptions}
              selectedOption={isApprovedLayout}
              onSelect={selectIsApprovedLayout}
              optionKey="name"
              isDependent={false}
            />

            {/* is Approved Layout yes Radio Button  (16)*/}
            {isApprovedLayout && isApprovedLayout?.name === "Yes" && (
              <span className={"form-pt-dropdown-only"}>
                <CardLabel>{`${t("Ground Coverage %")} *`}</CardLabel>
                <TextInput
                  isMandatory={false}
                  optionKey="i18nKey"
                  t={t}
                  name="groundCoverages"
                  onChange={setgroundCoverage}
                  uploadMessage={uploadMessage}
                  value={groundCoverages}
                  {...(validation = {
                    isRequired: true,
                    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                    type: "text",
                    title: t("TL_NAME_ERROR_MESSAGE"),
                  })}
                />
                {/* is Approved Layout yes Radio Button  (16)*/}
                <CardLabel>{`${t("FAR")} *`}</CardLabel>
                <TextInput
                  isMandatory={false}
                  optionKey="i18nKey"
                  t={t}
                  name="fars"
                  onChange={setFar}
                  uploadMessage={uploadMessage}
                  value={fars}
                  {...(validation = {
                    isRequired: true,
                    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                    type: "text",
                    title: t("TL_NAME_ERROR_MESSAGE"),
                  })}
                />
                {/* is Approved Layout yes Radio Button  (17)*/}
                <CardLabel>{`${t("Is plot has special required value of Setback?")} *`}</CardLabel>
                <RadioOrSelect
                  t={t}
                  options={proposalTypeOptions}
                  selectedOption={isPlotSetback}
                  onSelect={selectIsPlotSetback}
                  optionKey="name"
                  isDependent={false}
                />
                {isPlotSetback && isPlotSetback?.name === "Yes" && (
                  <span className={"form-pt-dropdown-only"}>
                    {/* is Approved Layout yes Radio Button  (16)*/}
                    <CardLabel>{`${t("Setback Front")} *`}</CardLabel>
                    <TextInput
                      isMandatory={false}
                      optionKey="i18nKey"
                      t={t}
                      name="setbackFronts"
                      onChange={setIssetbackFront}
                      uploadMessage={uploadMessage}
                      value={setbackFront}
                      {...(validation = {
                        isRequired: true,
                        pattern: "^[0-9]+$",
                        type: "text",
                        title: t("TL_NAME_ERROR_MESSAGE"),
                      })}
                    />
                    {/* Setback Rear Radio Button  (16)*/}
                    <CardLabel>{`${t("Setback Rear")} *`}</CardLabel>
                    <TextInput
                      isMandatory={false}
                      optionKey="i18nKey"
                      t={t}
                      name="setbackRears"
                      onChange={isSetbackRear}
                      uploadMessage={uploadMessage}
                      value={setbackRear}
                      {...(validation = {
                        isRequired: true,
                        pattern: "^[0-9]+$",
                        type: "text",
                        title: t("TL_NAME_ERROR_MESSAGE"),
                      })}
                    />
                    {/* Setback Side Radio Button  (16) */}
                    <CardLabel>{`${t("Setback Side")} *`}</CardLabel>
                    <TextInput
                      isMandatory={false}
                      optionKey="i18nKey"
                      t={t}
                      name="backSides"
                      onChange={isSetbackSide}
                      uploadMessage={uploadMessage}
                      value={backSide}
                      {...(validation = {
                        isRequired: true,
                        pattern: "^[0-9]+$",
                        type: "text",
                        title: t("TL_NAME_ERROR_MESSAGE"),
                      })}
                    />
                  </span>
                )}
              </span>
            )}

            <CardLabel>{`${t("Owner Name")} *`}</CardLabel>

            <TextInput
              isMandatory={false}
              optionKey="i18nKey"
              t={t}
              name="applicantName"
              onChange={setApplicantName}
              uploadMessage={uploadMessage}
              value={name}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                type: "text",
                title: t("TL_NAME_ERROR_MESSAGE"),
              })}
            />

            <CardLabel>{`${t("BPA_PLAN_DIAGRAM_LABEL")} *`}</CardLabel>
            <UploadFile
              id={"edcr-doc"}
              extraStyleName={"propertyCreate"}
              accept=".dxf"
              onUpload={selectfile}
              onDelete={() => {
                setUploadedFile(null);
                setFile("");
              }}
              message={uploadedFile ? `1 ${t(`PT_ACTION_FILEUPLOADED`)}` : t(`ES_NO_FILE_SELECTED_LABEL`)}
              uploadMessage={uploadMessage}
            />
            <div style={{ disabled: "true", height: "30px", width: "100%", fontSize: "14px" }}>{t("EDCR_UPLOAD_FILE_LIMITS_LABEL")}</div>
            {isShowToast && <Toast error={isShowToast.key} label={t(isShowToast.label)} onClose={() => setIsShowToast(null)} isDleteBtn={true} />}
          </FormStep>
          {/* <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                onClick={() => reset()}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
              />
            </div>
          </div> */}
        </div>
        {/* </form> */}
      </section>
    </React.Fragment>
  );
};

export default EDCRForm2;
